import Swiper from 'swiper/bundle';

class SwiperArticleList {
  constructor({ elm }) {
    // slideの個数を取得
    let swiperItems = elm.querySelectorAll('.swiper-slide').length;

    // swiperの指定
    let articleListSwiper;

    // swiper設定
    const createArticleListSwiper = function (loop) {
      let param = {
        slidesPerView: 1.5,
        spaceBetween: 24,
        centeredSlides: true,
        loop: true,
        allowTouchMove: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 1500,
        navigation: {
          nextEl: elm.querySelector("[data-role='article-list-swiper-nav-next']"),
          prevEl: elm.querySelector("[data-role='article-list-swiper-nav-prev']"),
        },
        breakpoints: {
          1012: {
            slidesPerView: 3.4,
            centeredSlides: false,
          },
        },
      };
      // loopしない場合は下記を書き換え
      if (!loop) {
        param.loop = false;
        param.allowTouchMove = false;
        param.centeredSlides = false;
      }
      articleListSwiper = new Swiper(elm, param);
    };

    // 読み込まれた時
    function windowWidthMonitor(load) {
      if (!load) {
        articleListSwiper.destroy(false, true);
        elm.classList.add('is-noslide');
      }
      if (swiperItems <= 3) {
        if (1012 < window.innerWidth) {
          createArticleListSwiper(false);
          elm.classList.add('is-noslide');
        } else {
          createArticleListSwiper(true);
          elm.classList.remove('is-noslide');
        }
      } else {
        createArticleListSwiper(true);
      }
    }

    // スライドの個数が5枚以下の時はリサイズイベント
    if (swiperItems <= 3) {
      window.addEventListener('resize', function () {
        windowWidthMonitor(false);
      });
    }

    windowWidthMonitor(true);
  }
}

export default SwiperArticleList;
